import { buildBillingContext } from '@/apiCalls/billingContext';
import { postUrl } from '@/apiCalls/fetch';
import { EVehicleAssetType } from '@/context/borrower';
import { IMakeApiResults } from '@/context/display';
import { getGlassAssetType } from '@/utils/glassGuideHelpers';

export async function getMake(
    partner: string,
    year: number,
    assetType?: EVehicleAssetType
): Promise<IMakeApiResults[]> {
    const url = `/api/asset/select/${partner}/${getGlassAssetType(assetType)}/${year}`;
    return postUrl<IMakeApiResults[]>(url, { billingContext: buildBillingContext() });
}
